import { ReactNode } from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { BodySmall, Title6 } from '../styles/Typography'
import { ChartContainer } from './shared'

type Props = {
  title: string
  caption?: ReactNode
  legend?: ReactNode
  children: ReactNode
  footer?: ReactNode
}

export const ChartCard = ({ title, caption, legend, children, footer }: Props) => (
  <ChartContainer>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      {caption && <Caption>{caption}</Caption>}
      {legend}
    </CardHeader>
    {children}
    {footer}
  </ChartContainer>
)

const CardTitle = styled(Title6)`
  color: ${theme.color.plum};
`

const Caption = styled(BodySmall)`
  color: ${theme.color.greyBlue};
  margin-bottom: ${theme.spacing.xsmall}px;
`

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing.xsmall}px;
  padding: 0 ${theme.spacing.tiny}px;
  margin-bottom: ${theme.spacing.mediumLarge}px;
`
